<template>
    <div class="page light">

        <Top></Top>

        <div class="hidden-xl hidden-lg navbar navbar-style-1">
            <div class="navbar-inner">
                <a v-on:click="$root.back();" class="link back" v-bind:class="{'hidden': chamada}">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.439312 13.0606L5.75391 18.3752C6.04683 18.6682 6.43069 18.8146 6.81459 18.8146C7.1985 18.8146 7.58236 18.6682 7.87528 18.3752C8.46103 17.7894 8.46103 16.8397 7.87528 16.2539L5.12133 13.5H22.5C23.3284 13.5 24 12.8284 24 12C24 11.1716 23.3284 10.5 22.5 10.5H5.12133L7.87528 7.7461C8.46103 7.1603 8.46103 6.21057 7.87528 5.62477C7.28944 5.03898 6.33975 5.03898 5.75391 5.62477L0.439312 10.9394C-0.146437 11.5251 -0.146437 12.4749 0.439312 13.0606Z" fill="black"></path>
                    </svg>
                </a>
                <div class="title" style="">Agendamento</div>
                <div class="right">
                    <a  class="link hidden">
                        <i class="las la-shopping-cart"></i>
                    </a>
                </div>
            </div>
        </div>
        <div class="page-content content-area pt-40 bottom-sp60" style="background: #f7f7f7" v-if="detalhes">
                
            <div class="container hidden-xs hidden-md">
                <h2>Detalhes do agendamento</h2>
            </div>

            <div class="block mb-0 pb-0">
                <div class="row">

                    <!--  -->

                    <button type="button" class="button mb-10 button-fill button-large color-orange" v-on:click="alterarStatus(detalhes.cod, 'iniciar', false)" v-if="($root.user.tipo == 'prestador' || $root.user.tipo == 'admin') && detalhes.status == 1 && !chamada">
                        <i class="las la-play"></i>
                        Iniciar atendimento
                    </button>
                    
                    <button type="button" class="button mb-10 button-fill button-large color-orange" v-on:click="alterarStatus(detalhes.cod, 'iniciar', false)" v-if="detalhes.agendaTipo == 'online' && ($root.user.tipo == 'prestador' || $root.user.tipo == 'admin') && (detalhes.status == 2 || detalhes.status == 3) && !chamada">
                        <i class="las la-play"></i>
                        Abrir videoconferência
                    </button>                                                            

                    <button type="button" class="button mb-10 button-fill button-large color-orange" v-on:click="alterarStatus(detalhes.cod, 'iniciar-contratante', false)" v-if="($root.user.tipo == 'contratante') && (detalhes.status == 2) && !chamada">
                        <i class="las la-play"></i>
                        Iniciar atendimento
                    </button>   

                    <button type="button" class="button mb-10 button-fill button-large color-orange" v-on:click="alterarStatus(detalhes.cod, 'iniciar-contratante', false)" v-if="detalhes.agendaTipo == 'online' && ($root.user.tipo == 'contratante') && (detalhes.status == 3) && !chamada">
                        <i class="las la-play"></i>
                        Abrir videoconferência
                    </button>                                        
                    

                    <button type="button" class="button mb-10 button-fill button-large color-green" v-on:click="alterarStatus(detalhes.cod, 'concluir', false)" v-if="detalhes.status == 3">
                        <i class="las la-check-circle"></i>
                        Concluir atendimento
                    </button>
                    

                    <button type="button" class="button mb-10 button-outline color-red" v-on:click="cancelar(detalhes.cod)" v-if="detalhes.status == 1">
                        <i class="las la-times"></i>
                        Cancelar agendamento
                    </button>                    
                </div>

                <div class="chamada-video" style="" v-if="!cordova && detalhes.status < 4 && detalhes.status > 1 && chamada">
                    <div class="content" style="width: 100%;">
                        <div id="remote-media" v-show="chamada"></div>
                        <div id="local-media" v-show="chamada"></div>
                    </div>

                    <button v-show="chamada" class="mute-audio" v-on:click="muteAudio()">
                        <i class="las la-microphone-slash" v-show="!mute.audio"></i>
                        <i class="las la-microphone" v-show="mute.audio"></i>
                    </button>
                    <button v-show="chamada" class="mute-video" v-on:click="muteVideo()">
                        <i class="las la-video-slash" v-show="!mute.video"></i>
                        <i class="las la-video" v-show="mute.video"></i>
                    </button>                                       
                </div>    

            </div>

            <div class="card data-table data-table-collapsible data-table-init mt-0">
                <div class="card-header">
                    <div class="data-table-title">Detalhes do agendamento</div>
                    <div class="data-table-actions">
<!--                         <a class="link icon-only">
                            <i class="icon f7-icons">line_horizontal_3_decrease</i>
                        </a> -->
                        <a class="link icon-only" v-on:click="get">
                            <i class="las la-sync-alt"></i>
                        </a>
                    </div>
                </div>
                <div class="card-content">
                    <table>
<!--                         <thead>
                            <tr>
                                <th class="label-cell">Dessert (100g serving)</th>
                                <th class="numeric-cell">Calories</th>
                                <th class="numeric-cell">Fat (g)</th>
                                <th class="numeric-cell">Carbs</th>
                                <th class="numeric-cell">Protein (g)</th>
                            </tr>
                        </thead> -->
                        <tbody>
                            <tr>
                                <td class="label-cell" data-collapsible-title="Id">
                                    <span>
                                        #{{detalhes.id}}
                                    </span>
                                </td>
                                <td class="numeric-cell" data-collapsible-title="Status">
                                    <span>
                                        <small v-if="detalhes.status == 0">
                                            <span style="height: auto !important;" class="badge color-orange">
                                                Pagamento pendente
                                            </span>
                                        </small>
                                        <small v-if="detalhes.status == 1">
                                            <span style="height: auto !important;" class="badge color-orange">
                                                Agendado
                                            </span>
                                        </small>
                                        <small v-if="detalhes.status == 2">
                                            <span style="height: auto !important;" class="badge color-yellow">
                                                Aguardando paciente
                                            </span>
                                        </small> 
                                        <small v-if="detalhes.status == 3">
                                            <span style="height: auto !important;" class="badge color-blue">
                                                Atendimento em andamento
                                            </span>
                                        </small> 
                                        <small v-if="detalhes.status == 4">
                                            <span style="height: auto !important;" class="badge color-orange">
                                                Atendimento realizado
                                            </span>
                                        </small> 
                                        <small v-if="detalhes.status == 5">
                                            <span style="height: auto !important;" class="badge color-green">
                                                Atendimento realizado
                                            </span>
                                        </small> 
                                        <small v-if="detalhes.status == -1">
                                            <span style="height: auto !important;" class="badge color-red">
                                                Cancelado
                                            </span>
                                        </small>                                         

                            <!--             // pedidos_status
                                        //    -3 : apagada
                                        //    -2 : reagendar
                                        //    -1 : cancelada
                                        //    0 : pendente
                                        //    1 : agendada
                                        //    2 : iniciada prestador
                                        //    3 : iniciada paciente
                                        //    4 : finalizada
                                        //    5 : avaliada
 -->                                        
                                    </span>
                                </td>
                                <td class="numeric-cell" data-collapsible-title="Agendado para">
                                    <span>
                                        {{detalhes.dataExtenso}}
                                    </span>
                                </td>
                                <td class="numeric-cell" data-collapsible-title="Serviço">
                                    <span>
                                        {{detalhes.descricao}}
                                    </span>
                                </td>
                                <td class="numeric-cell" data-collapsible-title="Tipo do atendimento">
                                    <span v-if="detalhes.agendaTipo == 'online'">
                                        Atendimento online
                                    </span>
                                    <span v-if="detalhes.agendaTipo == 'presencial'">
                                        Atendimento presencial
                                    </span>
                                    <span v-if="detalhes.agendaTipo == 'domiciliar'">
                                        Atendimento domiciliar
                                    </span>
                                </td> 
                                <td class="numeric-cell" data-collapsible-title="Paciente">
                                    <span>
                                        {{detalhes.contratante.nome}}
                                    </span>
                                </td>
                                <td class="numeric-cell" data-collapsible-title="Profissional">
                                    <span>
                                        {{detalhes.prestador.nome}}
                                    </span>
                                </td>                                      
                                <td class="numeric-cell" data-collapsible-title="Iniciado em" v-if="detalhes.iniciado != '0000-00-00 00:00:00'">
                                    <span>                                 
                                        {{detalhes.iniciado | formatDate}}h
                                    </span>
                                </td>
                                <td class="numeric-cell" data-collapsible-title="Finalizado em" v-if="detalhes.finalizado != '0000-00-00 00:00:00'">
                                    <span>                                 
                                        {{detalhes.finalizado | formatDate}}h
                                    </span>
                                </td>                                

                                <td class="numeric-cell" data-collapsible-title="Hora de início prevista">
                                    <span>                                 
                                        {{detalhes.horaInicio.substr(0, 5)}}h
                                    </span>
                                </td>
                                <td class="numeric-cell" data-collapsible-title="Hora final prevista">
                                    <span>                                 
                                        {{detalhes.horaFinal.substr(0, 5)}}h
                                    </span>
                                </td>           
                                <td class="numeric-cell" data-collapsible-title="Avaliação" v-if="detalhes.avaliacaoContratante != 0">
                                    <span>                                 
                                        <b>Nota:</b> {{detalhes.avaliacaoContratanteNota}}   
                                    </span>
                                    <span v-if="detalhes.avaliacaoContratanteTexto">                                 
                                          /  <b>Comentário:</b> {{detalhes.avaliacaoContratanteTexto}}
                                    </span>                                    
                                </td>                                                                                            
                                <td class="numeric-cell" data-collapsible-title="Forma de pagamento">
                                    <span>                                 
                                        {{detalhes.formaPagamentoNome}}
                                    </span>
                                </td>
                                <td class="numeric-cell" data-collapsible-title="Última atualização">
                                    <span>                                 
                                        {{detalhes.datahora | formatDate}}
                                    </span>
                                </td>
                                <td class="numeric-cell" data-collapsible-title="Efetuado em">
                                    <span>                                 
                                        {{detalhes.datahora | formatDate}}
                                    </span>
                                </td>
                                <td v-if="detalhes.cupomNome" class="numeric-cell" data-collapsible-title="Cupom de desconto">
                                    <span>                                 
                                      {{detalhes.cupomNome}}
                                    </span>
                                </td>
                                <td v-if="detalhes.cupomNome" class="numeric-cell" data-collapsible-title="Desconto">
                                    <span>                                 
                                        R$ {{detalhes.desconto  | toMoney}}
                                    </span>
                                </td>                                                                
                                <td class="numeric-cell" data-collapsible-title="Valor que receberei" v-if="$root.user.tipo == 'prestador'">
                                    <span style="font-weight: bold; color: #222">                                 
                                        R$ {{detalhes.prestadorSplitValor  | toMoney}}
                                    </span>
                                </td>
                                <td class="numeric-cell" data-collapsible-title="Valor total">
                                    <span>                                 
                                        R$ {{detalhes.total  | toMoney}}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

        </div>
        
        <!-- <Toolbar></Toolbar> -->
    </div>
</template>

<script>
import Toolbar from './Toolbar'
import Top from './Top'
export default {
    name: 'DetalhesPedidos',
    components: {
        'Toolbar': Toolbar,
        'Top': Top
    },          
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            if (time) {
                d = time.split(":");
                time = d[0] + ":" + d[1];
            }
            // return formatDate(value.replace(" ", "T")) + " " + formatHours(value.replace(" ", "T"));
            return date + (time ? (" " + time) : "");
        },
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2})                
            } else {
                return "0,00";
            }
        },        
    },      
    data () {
        var self                    = this;
        return {
            "chamada":              null,
            "mute": {
                "audio": false,
                "video": false,
            },
            "realtime":             {},            
            "loading": {
                "submit":           false
            },  
            "detalhes":             null,
            "form": {
            }            
        }
    },
    watch: {
        // "form.metodo": function(val) {
        //     var self = this;
        //     console.log("watch form.metodo >>", val);

        //     if (val == "consulta" && !self.form.nome) {
        //         self.form.nome      = "Consulta";
        //         self.$forceUpdate();
        //     }
        // }
    },
    methods: {  
        initChamada: function(token, room) {
            var self        = this;
            console.log("initChamada()", token, room);
            if (self.chamada) return false;

            self.chamada    = {
                "token":    token,
                "room":     room
            };

            self.$forceUpdate();

            window.__chamada = self.chamada;

            if (!window.device) window.device = {};
            if (window.device.platform == "iOS" || window.device.platform == "Android") {
        
                self.openChamada();
                return false;
            } 

            // $(".dashboard-content-inner")[0].scrollTo({
            //     top:    $(".dashboard-content-inner").height()
            // });     

            var Video = Twilio.Video;
            Video.createLocalVideoTrack().then(track => {
                var localMediaContainer = document.getElementById('local-media');
                window.__track = track;
                localMediaContainer.appendChild(track.attach());
            });

            Video.connect(token, {
                name:           room,
                bundlePolicy:   'max-compat'
            }).then(room => {
                console.log(`Successfully joined a Room: ${room}`);

                loading.hide();

                self.room   = room;
                window.__room = room;
                // _room       = room;

                var remoteMediaContainer = document.getElementById('remote-media');
                    room.participants.forEach(function(participant) {
                    console.log("Already in Room: '" + participant.identity + "'");
                    participantConnected(participant, remoteMediaContainer);
                });

                room.on('participantConnected', participant => {
                    console.log(`A remote Participant connected: ${participant}`);
                    participantConnected(participant);
                });

                room.on('participantDisconnected', participant => {
                    console.log(`A remote Participant connected: ${participant}`);
                    participantDisconnected(participant);
                });

            }, error => {
                loading.hide();
                console.error(`Unable to connect to Room: ${error.message}`);
            });

            function participantConnected(participant) {
                console.log('Participant "%s" connected', participant.identity);
                const div   = document.createElement('div');
                div.id      = participant.sid;
                participant.on('trackSubscribed', (track) => {
                    trackSubscribed(div, track)
                });
                participant.on('trackUnsubscribed', trackUnsubscribed);
                participant.tracks.forEach(publication => {
                    if (publication.isSubscribed) {
                        trackSubscribed(div, publication.track);
                    }
                });

                document.getElementById('remote-media').appendChild(div);
            }

            function participantDisconnected(participant) {
                console.log('Participant "%s" disconnected', participant.identity);

                var div     = document.getElementById(participant.sid)
                if (div) {
                    div.remove();
                }
            }

            function trackSubscribed(div, track) {
                div.appendChild(track.attach());
            }

            function trackUnsubscribed(track) {
                track.detach().forEach(element => element.remove());
            }

        },         
        initRealTime: function() {
            var self                = this;
            Pusher.logToConsole     = true;

            self.realtime           = {};
            self.realtime.client    = new Pusher(self.$root.config.pusher.key, {
                cluster: 'mt1',
                activityTimeout: 2000,
                // enabledTransports: ['ws']                
            });
            self.realtime.channelPedido    = self.realtime.client.subscribe("pedidos-" + self.form.cod);
            self.realtime.channelPedido.bind("update", function(data) {
                console.log("atualizacao no pedido", data);

                if (window.__app.$route.name != "DetalhesPedidos") {
                    console.log("Trocou de rota, entao finaliza pusher");
                    self.realtime.client.disconnect();
                    self.$forceUpdate();
                }

                self.setPedido(data.pedido);
                
            });    

            self.realtime.channel   = self.realtime.client.subscribe("chamada-" + self.form.cod + "-" + self.$root.user.cod);
            self.realtime.channel.bind("update", function(data) {
                console.log("atualizacao na chamada", data);
                if (data.tipo == "token") {
                    self.initChamada(data.token, data.room);
                }
                if (data.tipo == "fim") {
                }
            });             
        },
        muteAudio: function() {
            var self = this;
            if (!self.mute.audio) {
                self.room.localParticipant.audioTracks.forEach((publication) => { 
                    publication.track.disable(); 
                });
                self.mute.audio = true;
            } else {
                self.room.localParticipant.audioTracks.forEach((publication) => { 
                    publication.track.enable(); 
                });                 
                self.mute.audio = false;
            }
            self.$forceUpdate();
        },
        muteVideo: function() {
            var self = this;
            if (!self.mute.video) {
                self.room.localParticipant.videoTracks.forEach((publication) => { 
                    publication.track.disable(); 
                });
                self.mute.video = true;
            } else {
                self.room.localParticipant.videoTracks.forEach((publication) => { 
                    publication.track.enable(); 
                });                 
                self.mute.video = false;
            }
            self.$forceUpdate();
        },             
        setPedido: function(pedido) {
            console.log("setPedido()", pedido);
            var self = this;
            self.detalhes = JSON.parse(JSON.stringify(pedido));
            self.$forceUpdate();

            if (pedido.status == 4 && self.chamada) {
                console.log("Fim teleconsulta")
                window.__track.stop();
                window.__room.disconnect();
                self.chamada = null;
                self.realtime.client.disconnect();
                self.$forceUpdate();
                window.twiliovideo.closeRoom();                
                // self.initChamada(obj.TELECONSULTA.objeto.twilioToken, obj.NR_SEQUENCIA);
            }

        },
        checkPermissions: function() {
            console.log("checkPermissions()");
            if (window.device) {
                if (window.device.platform === "Android") {
                    window.cordova.plugins.permissions.requestPermissions([window.cordova.plugins.permissions.CAMERA, window.cordova.plugins.permissions.RECORD_AUDIO, window.cordova.plugins.permissions.MODIFY_AUDIO_SETTINGS]);            
                }   
            }
            if (window.cordova && window.cordova.plugins && window.cordova.plugins.backgroundMode) {
                window.cordova.plugins.backgroundMode.enable();
            }                          
        },      
        openChamada: function() {
            console.log("openChamada()");
            var self                = this;
            window.twiliovideo.openRoom(self.chamada.token, self.chamada.room, function(e) {
                console.log("initChamada() -> onEvent()", e);

                if (e == "CLOSED" || e == "DISCONNECTED" || e == "PARTICIPANT_DISCONNECTED") {
                    self.chamada = null;
                    if (window.__track) {
                        window.__track.stop();
                    }
                    if (window.__room) {
                        window.__room.disconnect();                    
                    }
                    window.twiliovideo.closeRoom();
                    self.$forceUpdate();
                }
            }, {
                "primaryColor":     "#00bcb4",
                "secondaryColor":   "#00bcb4",
                "handleErrorInApp": true,
                // "hangUpInApp":      true
            });
            // self.$app.preloader.hide();
        },             
        cancelar: function(cod) {
            
            console.log("cancelar()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja cancelar?", function() {
                var texto               = prompt("Qual o motivo do cancelamento?");
                if (!texto)             return false; 
                self.loading.cancelar   = true;
             
                var form = {
                    "_cod":         self.$root.user.cod, 
                    "_token":       self.$root.user.token,
                    "cod":          cod,
                    "status":       "cancelar",
                    "texto":        texto
                };                

                loading.show();
                
                axios.put("api/pedidos.php", form)
                .then(response => {
                    console.log("cancelar() response", response)
                    self.loading.cancelar    = false;
                    self.get(true);
                    alert(response.data.message);
                })
                .catch(error => {
                    console.log("cancelar() error", error)
                    loading.hide();
                    self.loading.cancelar    = false;
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        },
        alterarStatus: function(cod, status, message) {
            console.log("alterarStatus()", cod);
            
            var self                = this;
            

            var form = {
                "_cod":         self.$root.user.cod, 
                "_token":       self.$root.user.token,
                "cod":          cod,
                "status":       status
            };                

            loading.show();
            
            axios.put("api/pedidos.php", form)
            .then(response => {
                console.log("alterarStatus() response", response)
                loading.hide();
                self.get(true);
                if (message) alert(response.data.message);

            })
            .catch(error => {
                console.log("alterarStatus() error", error)
                loading.hide();
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });
        },      
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "cod":          self.form.cod
                    }
                };

                axios.get("api/pedidos.php", form)
                .then(response => {
                    
                    console.log("get() response", response);
                    self.loaded         = true;
                    // self.detalhes       = response.data.result;
                    self.setPedido(response.data.result);
                    // if (response.data.result.pago == 1 && response.data.result.metodo == "online") {
                    //     self.checkPermissions();
                    // }

                    self.$root.getAvaliacoesPendentes();
                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$root.back();
                        }
                    }                    
                });   
            });   
        }        
    },    
    activated: function() {
        var self = this;
        console.log("activated", self);

        self.cordova = window.cordova;

        if (!self.$route.query.c) {
            self.$root.back();
            return false;
        }
        self.form.cod = self.$route.query.c;

        loading.show();

        Promise.all([
            self.get()
        ]).then(function() {
            
            if (self.detalhes.agendaTipo == 'online') {
                self.checkPermissions();
            }
            self.initRealTime();
            setTimeout(function() {
                loading.hide();
            }, 500);
            
        }).catch(function(error) {
            loading.hide();
        });  


    },
    // activated: function() {
        // var self = this;
        // self.init();
    // },       
    mounted: function() {
    }   
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
   
    .page-detalhespedidos td span:not(.badge) {
        color: #222;
    }

    .page-detalhespedidos .badge {
        line-height: 100%;
        padding: 4px;        
    }

    .page-detalhespedidos .data-table.data-table-collapsible td { 
        border-bottom: 1px solid #efefef;
    }

    .link.back.hidden {
        opacity: 0 !important;
        pointer-events: none !important;
    }

    .button-fill.color-grey {
        background: #ddd !important;
        color: #666 !important;
    }

    .block .button-large {
        font-weight: bold;
        font-size: 18px
    }


    #remote-media {
        width: 100%;
        text-align: center;
        height: 100%;
    }

    #remote-media video {
        max-width: 100% !important;
        width: auto !important;
        height: 80vh !important;        
        /*height: 80vh;*/
        /*width: auto;*/
        margin-top: 6px;
    }

    #local-media {
        display: flex;
        position: absolute;
        right: 10px;
        bottom: 10px;
        width: 100px;
        height: 100px;
        background: #000;
        /*border: 1px solid #ddd;*/
    }

    #local-media video {
        max-width: 100% !important;
    }


    .chamada-video {
        display: flex;
        align-items: center;
        background-color: #ddd; 
        height: 80vh;   
        position: relative;
        /*background-image: url(/static/images/video-placeholder.png);*/
        /*background-size: 80%;*/
        /*background-position: center;*/
        /*background-repeat: no-repeat;*/
    }

    .chamada-video .placeholder {
        width: 100%;
        opacity: 0.1;
    }

    .chamada-video p {
        text-align: center;
        color: #fff;
        width: 100%;
        padding-left: 20px;
        padding-right: 20px;    
        position: absolute;
    }


    .mute-audio {
        position: absolute;
        bottom: 10px;
        left: 10px;
        background: #59ba92;
        border: 2px solid #ddd;
        border-radius: 50%;
        height: 50px;
        width: 50px;
    }
    .mute-audio i {
        font-size: 30px;
        color: #fff;
        position: relative;
        top: 2px;   
    }

    .mute-video {
        position: absolute;
        bottom: 10px;
        left: 70px;
        background: #59ba92;
        border: 2px solid #ddd;
        border-radius: 50%;
        height: 50px;
        width: 50px;
    }
    .mute-video i {
        font-size: 30px;
        color: #fff;
        position: relative;
        top: 2px;   
    }    


</style>



// WEBPACK FOOTER //
// src/components/DetalhesPedidos.vue